import { Component, Input } from '@angular/core';
import { saveAs } from 'file-saver';
import { SheetIssue } from './distributor-setup.service';

/** The answer to a setup / target sheet: saved or checked, what it does, the rows to fix and the notes. */
@Component({
  selector: 'crm-sheet-result',
  templateUrl: './sheet-result.component.html',
  styles: ['.ds-counts { margin: 4px 0 10px; } .ds-count { display: inline-block; margin: 0 18px 6px 0; white-space: nowrap; }']
})
export class SheetResultComponent {
  @Input() result: any;
  /** label -> result field, shown in this order when present */
  @Input() counts: { label: string; field: string }[] = [];

  /** numbers with thousands separators (2 decimals at most), lists joined, text as it is */
  show(v: any): string {
    if (Array.isArray(v)) return v.join(', ');
    if (typeof v === 'number') return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
    return v == null ? '' : String(v);
  }

  get errors(): SheetIssue[] { return (this.result && this.result.errors) || []; }
  get notes(): SheetIssue[] { return (this.result && this.result.notes) || []; }
  get prices(): any[] { return (this.result && this.result.prices) || []; }

  /** the problems and notes as a CSV (opens in Excel) */
  download() {
    const esc = (v: any) => { const t = v == null ? '' : String(v); return /[",\n]/.test(t) ? '"' + t.replace(/"/g, '""') + '"' : t; };
    const lines = ['Kind,Row,Code,Message'];
    this.errors.forEach(e => lines.push(['Problem', e.row || '', e.code || '', e.message].map(esc).join(',')));
    this.notes.forEach(e => lines.push(['Note', e.row || '', e.code || '', e.message].map(esc).join(',')));
    saveAs(new Blob(['﻿' + lines.join('\n')], { type: 'text/csv;charset=utf-8' }), 'Sheet problems.csv');
  }
}
